import React from 'react';
import { Icon } from '@blueprintjs/core';

interface Component_Props {
    label: string,
    sub_label?: string,
    title_type: number
}

function Component(props: Component_Props) {

    if(props.title_type === 1) {
        return (
            <div style={{ display: "flex", width: "100%", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "10%", color:"#6f7288" }}>
              <span style={{ fontSize: "15px", fontWeight: "bold" }}>{props.label}</span>
              <span style={{ fontSize: "10px" }}>{props.sub_label}</span>
            </div>
        )
    }
    else {
        return <div style={{display: "flex", alignItems: "center", justifyContent: "center", height:"10%", width:"100%"}}>
                    <Icon icon="dollar" color='#6f7288' style={{margin:"-0.5% 5% 0 0"}}/>
                    <span style={{ color:"#6f7288", textAlign: "center", fontSize: "15px", fontWeight: "bold", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", marginRight:"10%" }}>{props.label}</span>
               </div>
    }
}



export default Component;

